"use client";

import type { ComponentProps, FC } from "react";
import { cn } from "../../utils";
import useSlider from "./hooks/useSlider";
import { sliderItemVariants } from "./variants";

type Props = ComponentProps<"div"> & {
  align?: "start" | "center";
};

const SliderItem: FC<Props> = ({ className, align, ...props }) => {
  const { registerItem } = useSlider();

  return (
    <div
      ref={registerItem}
      role="group"
      aria-roledescription="slide"
      data-slot="slider-item"
      className={cn(sliderItemVariants({ align }), className)}
      {...props}
    />
  );
};

export default SliderItem;
